const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const RequalifyEventMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QCcwEcCuBDANgSwDMBPAWjADcwA7AFwDo8IcwBiAZQBUBBAJQ4G0ADAF1EoAA4B7WHhp5JVMSAAeiEgGZBdAKzqAHADZtARkF7je9foDsBgDQgiagCyCDdK5sHPn67YIAmS3UAXxCHVExcQlIKanosAGM5ShYAVQAFABEuDgBRAH0AITzePJ4CjgB5AGk8gDkhUSQQKRk5BSVVBBI9XTpTTW1tawBOA1HjSYcnHqmtQUErC1G9NwCDALCI9Gx8YjJKWjoklLA6WDBmZPkqAAJJAjuaAAswO8SFS8xqRNZ6vIADQEIiUbVkty6iAszjohmMxg2zjGo2sxnUM0Qzm0ox0yL01jcYymY22IEiexih3iJxulAuVzANwUDyer3enyo3wwv1YXCKXHqWSq9QKPDyAEU0nlOHksk0wdIIZ0Wt0SM4Ato6M5LBZ1NZrBsRs5MQgAoJjHQjGZ9aMAtZ9dZhmSKdEDnFjqc8PTLtcOvdHs83h8vrteQwmKwAMIitiS6X1KOFOMAGTyUfy8tBLXB-qhZssdA2ATtiP042c9kciENOgM6gMBLMATLo1GLt2btiRwSdPOvqZ-tZQY5oZ+VD+dE+AFtxBgaBzkBDErIiCwIApzngqORJABrc6u-bdmlen2M5kBtnBznc8MzucLj5LuQrmhEBDb3eJLD+poKnMlTzVVEHUYxYTRNwcVcNs9BLU1zQCOF1GcCwSXUUZNCmDsomPalPT7Bk-VuYd2RDLkwwnc4H3nRdl1XFgwGQZBJGQOhxBwX8CFY6c6CPKkPV7M4iMHEjAzI29KMnGin0SF88DfD8v0kH8-xEACJCAyEQIQdFRlhdELURVDAgmaxTRhDx7UrYwTAtPxLBwyl3R7WlhMYeJCAU38xOvOjXwYjJxQANQASSqNI2A01otJVUBugCWE3FMAxG1GNx1ACfVtFNbFcW0fFCQMYlUXbcJyU7PDBLc70twgTyCG8odxJveTFJYAFgWi3NtPi0C6AtTZKz0QwJiy+Dq104Z1G1bxsWMB0GwCZanK7fChNqiMGqa3yR2fej3ynN5Ej3O4B2SSByLvKiWG62LFB0oIZu0Yr0UbMDVhbU1DWsOhJkNVwG3+vQyp2XCBNcs86u21TdoktrVyOplTvOhcICuqTWH4Yxmk09pepURB-C0ZxJlWAxsWRcDjG++0-oWqZJhQ-x7VWqrIcIjzaC82GWRa-yFMRmSsAAI2YfaAsOmSBfajcqC3Hd90PSqIdPTn6u5xreavPa5IOogp0kWd51F8W9clg3pYlwX30-RXtf-bM8eVB6+oQZEkKw1Cy0CEsMUmhEEToaw9ErRaglQ7Q2dVgj3I1uQtZ8vm-OtxTDeNmhTZloWjcfbP30Y5jWPYziaG45BeP4ly1bjmGk51+H9fTx8s9TnOM-zpT7frx3cZi-G4sJ92CWDqZ9W9ysggCCy-BmkPtD6MDBGGTYtnKquT1jzauYTnbk91hGpdzk2xc7iNmHYPJgvKUKOAATQKVN00zO6B9doeHVxSwjAMeY5vGCyCItAR1SolZahoCrR2rlvekO8eb11Iq1JuwtT5t0OowC+QUqgCiKKFFMt8H5PwzHKV+Lt8wkAsFaA01hKxLFGLoNYehAGmCLKHVKdlSbgSgZvDa9JOSNQrncUWWAqByxYPyQUwpGhO37mQnSGhsQ6F0MteYJYSxMMmgo2EGpCQGgKgiMYehuHrRqnwhQAjpxCJFiIsRUZBRJhTAUCRQoRSkOAm7EgLZfqM0yiHTYOJNQ5QDsYdwaJtAtnoSMNh6JjHVShnxFWxA7jVQpPsLARBtxQGST2dcm4GCKwPAk8G0DeHK2KUQbJNJUmEHSZkyptA7bfh7upGRPVB7dBCbiGhqwQmaBGpsf2swvGWgsH0fwhJAgNliRzYSG96n0GqQQWpVAsmCULixNiHEuI8SKc5Hhpiyl7PmbstJGSVnzMaSpZpwg3EE26LaK0mUJhgXNAtEOCEMpUNcBsZejMKbTJrptOZ1VBJ3CrngSALAowpiqHGW57TEDml+phTwvzSaNnMpNRK6Vg5rCWDiAqSwDAApgf2DAiQ-iwFgCwZQsBM4LhOAQBcyAAAUxMACULAN4mPibAcllLYDwvfmqReVp6zhMSt4LKKEEIU0tJBHwNDFjFWsCS0pCSsCwH3mRcF2sWBBSvuFSKQr8wAz+uaUmfgQ76WGBZaas0fAmEWqvZwaqDkaq1Q3YMur64sHFFwNgIoChRgABKCgAOIkNafdfMyItSk3MKYTUnCTBVlmCEwQv1f5LERMvc0qxXXr0Sfs+JqBNXau9YkveVAoUigAGKhR4AAWRNY9QwOhywGh8JsNsFk+h6DhJmrwuh6GYULWDPZPLCJMQ2VCmFcLo1v3IfQ9wIw3A-0CKhGVWLvBagMEsWwbhzAvU2G6+JM7i6JGOqdC9yBnhEHEFjRdci3YIh1AMVElg1j+DApi2YmgDQDCyizd6ghUSqqLeUqdwlb1IxOskoud73yPtujjRUS6dIGK1EEWwMFxgEk2KaTKgQBojU1GiBEZMz3TsQ3Bm9iH70of4AEPubThXQkjkWYYhJEohJ+tPSaxGkJmDgieqYo1iWQcnXEwiZbPWIPeD6-0HUqgcFCnWh+4oMhVD4I-NIRQm233yBUUNEao2sZjTpQDVhUoDOWpYMYFlsTxpDvipsbywjlSoJIeq8AWjcsEuhl9Q8KGLFhGu9h+7ePbtmCQTYv1UIUc1G2dKOo3UYLAEF9xQ8-B-UYYYEwmE4J2lNCQEd9NDTLztG2AqRipNrRk2cLLdyXAOm1LqBzhojA0NKwiGapg1iEkjiYFCEGJ0NZmZtVGcMbxjh5FRZrCLdI+AGMvJYocaGpXW6VzUVozC9JoSvKwdXxvs0BeeYiFbRwUXHJODLi32O6TtKtn9G3Kz7v0KaPoHgyamAXhFrK1HhLTauxjW71Fj6yUPrMZ22Xuj9o8E6AxgMMKVlNL-OEv3M0h30DiE7FUoONe3vHeBzUU7mxtjD2RcO1BvqoV2j79D9BmFNCMX6g2TDFhCUYfHAXJuwJJ4nMnB9kHXrOheNGYP5t-Ae-mLKlpjR2klV+6a6OjAeEzQvNE2Jf4mCB8TuuwvG4WzoOXP46MKeKXmbLx6mxtS0PrBTe09p6FfczaPJNDZvBGHHQT6T-Poaa2rQptBltIet0t6uG3HjUr0823QhhLPJr0KQht0OpVzQs31wLw3M2z4oLNtD5utFQ-R6HsiZ6VrdAU0bOYQwFlEoQSsC2XQpgfCgz9xN87gfd7axD5Ho+GcI9F-u4BDDbtaseHrJYdROaEQWW8FoUbod1sgxS9niHVALFWJsYPNj5CMIDv0O9ZamxvBokAS53dtgZ8gyCBv3ZXZrdj+Cx0swRYUILV8AaWzDYLL0MtA1AwgyhMgtF52LWgyBWLWOUWWWVWR7DLw6Reg-0S2-1sFSj-x3X0HNUPzMApgANCHqzO1JUf2PGOVBXBUgEQOhDawJAKxG3AgmEsAQiBmDkNH0EQgwhDgfz5QpTgD81hxazNHfyZj6CmHtBGGPwQkMAHRGCK1tFgjG072IPVTk1ByUwJn30ehoQGAlV43tBBlsAsgdAS31DAJsw4Qf1vWoN0jA1kPUUtUowcmkLWB0GK2MgmAPSsNoyvWRgQw2UY0yxfxp10kYJ0AcMwicIXiIwtC1BtD60mFP3AMJwDzoFgySAFTuA1ghQgBsIRHrFYXQMCAdAmA1CIz0jcOCAwkbEbGMG8I2QZGQEoDvWsOCKEOpgS10ECEMEPVTSIw2AHQJERFMDRFDmCHqOLmsXRgpDgBoDyIiQ8GZkSmGFHQ0X-QGLhDRESkyhCTgjXjCCAA */
    predictableActionArguments: true,
    id: "requalify-event",

    states: {
      idle: {
        on: {
          START: {
            target: "active",
            cond: "validRequest",
            actions: [
              "saveReportId",
              "saveApiUrl",
              "saveAuthentication",
              "saveInitialChangeSet",
              "saveConsequenceTypes",
              "saveSeverityTypes",
              "saveProbabilityTypes",
            ],
          },
        },
      },

      active: {
        on: {
          UPDATE_BEARER_TOKEN: {
            target: "active",
            internal: true,
            cond: "validToken",
          },
        },

        states: {
          "selection of the consequence": {
            on: {
              NEXT: "identification of the criticity",
              ABANDON_REQUESTED: "confirm abandon",
            },

            states: {
              idle: {
                on: {
                  CONSEQUENCE_SELECTED: {
                    target: "compute criticity",
                    cond: "validSelectedConsequenceTypeObject",
                    actions: "saveSelectedConsequenceType",
                  },
                },
              },

              "compute criticity": {
                invoke: {
                  src: "computeCriticityFromConsequence",
                  onDone: {
                    target: "idle",
                    actions: "saveComputedCriticityType",
                  },
                  onError: {
                    target: "#requalify-event.active.error",
                    actions: "saveError",
                  },
                },
              },
            },

            initial: "idle",
          },

          "identification of the criticity": {
            on: {
              PREVIOUS: "selection of the consequence",
              NEXT: "reason of the requalification",
            },

            states: {
              "check selected consequence": {
                always: [
                  {
                    target: "forced criticity event",
                    cond: "forcedCriticity",
                  },
                  {
                    target: "computable criticity",
                    cond: "computableCrititicy",
                  },
                ],
              },

              "forced criticity event": {},

              "computable criticity": {
                initial: "idle",

                states: {
                  "compute criticity": {
                    invoke: {
                      src: "computeCriticity",

                      onDone: {
                        target: "idle",
                        actions: "saveComputedCriticityType",
                      },

                      onError: {
                        target: "#requalify-event.active.error",
                        actions: "saveError",
                      },
                    },
                  },

                  idle: {
                    on: {
                      SEVERITY_SELECTED: {
                        target: "compute criticity",
                        cond: "validSelectedSeverity",
                        actions: "saveSelectedSeverity",
                      },

                      PROBABILITY_SELECTED: {
                        target: "compute criticity",
                        cond: "validSelectedProbability",
                        actions: "saveSelectedProbability",
                      },
                    },
                  },
                },
              },
            },

            initial: "check selected consequence",
          },

          "confirm abandon": {
            on: {
              ABANDON: {
                target: "#requalify-event.idle",
                actions: "resetChangeSet",
              },
              CANCEL_ABANDON: "selection of the consequence",
            },
          },

          "requalify event": {
            states: {
              "requalifying event": {
                invoke: {
                  src: "requalifyEvent",
                  onDone: "event requalified",
                  onError: {
                    target: "#requalify-event.active.error",
                    actions: "saveError",
                  },
                },
              },

              "event requalified": {
                on: {
                  CLOSE: "#requalify-event.active.success",
                },
              },
            },

            initial: "requalifying event",
          },

          success: {
            after: {
              500: "#requalify-event.idle",
            },

            type: "final",
            entry: "resetChangeSet",
          },

          "reason of the requalification": {
            on: {
              PREVIOUS: "identification of the criticity",

              REASON_CHANGED: {
                target: "reason of the requalification",
                internal: true,
                actions: "saveRequalificationReason",
              },

              CONFIRM: {
                target: "requalify event",
                cond: "validReason",
              },

              NOTIFY_REPORT_SUBMITTER_CHANGED: {
                target: "reason of the requalification",
                internal: true,
                actions: "saveNotifyReportSubmitter"
              }
            },
          },

          error: {
            on: {
              CLOSE: "#requalify-event.idle",
            },

            states: {
              "check error type": {
                always: [
                  {
                    target: "access denied",
                    cond: "accessDeniedError",
                  },
                  {
                    target: "bad request",
                    cond: "badRequestError",
                  },
                  "server error",
                ],
              },

              "access denied": {},
              "server error": {},
              "bad request": {},
            },

            initial: "check error type",
            exit: "resetChangeSet",
          }
        },

        initial: "selection of the consequence",
      },
    },

    initial: "idle",
  },
  { actions: actions, guards: guards, services: services },
);

export { RequalifyEventMachine as RequalifyReportMachine };
